/**
 * Test if browser is touch screen
 *
 * @returns boolean
 */ export function isTouch() {
    return window.matchMedia('(hover: none), (pointer: coarse)').matches;
}
/**
 * Test if we have the virtual keyboard api avaliable
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/VirtualKeyboard_API
 *
 * @returns boolean
 */ export function virtualKeyboardApiSupported() {
    return 'virtualKeyboard' in navigator;
}
/**
 * Cleans href or src value so it only allows http and mailto
 *
 * @param linkOrSrc
 * @returns
 */ export function cleanLinkSrc(linkOrSrc) {
    if (!/^(http|https|mailto):\/\//.test(linkOrSrc !== null && linkOrSrc !== void 0 ? linkOrSrc : '')) {
        return '';
    }
    return linkOrSrc;
}
export function showKeyboard(editor) {
    var _navigator_virtualKeyboard;
    editor.commands.focus();
    virtualKeyboardApiSupported() && ((_navigator_virtualKeyboard = navigator.virtualKeyboard) === null || _navigator_virtualKeyboard === void 0 ? void 0 : _navigator_virtualKeyboard.show());
}
/**
 * This needed a workaround for: https://issues.chromium.org/issues/40912131
 */ export function hideKeyboard(editor) {
    if (virtualKeyboardApiSupported()) {
        navigator.virtualKeyboard.hide();
        setTimeout(()=>{
            const dom = editor === null || editor === void 0 ? void 0 : editor.view.dom;
            dom.virtualKeyboardPolicy = 'auto';
            dom.focus();
            dom.blur();
            dom.virtualKeyboardPolicy = 'manual';
        }, 100);
    }
}
export function isAndroid() {
    return navigator.userAgent.toLowerCase().indexOf('android') > -1;
}

//# sourceMappingURL=browser.js.map